import {DirectivesModule} from 'directives/module';
import {dateInputText} from 'directives/dateInputText';
import {datetimeInput} from 'directives/datetimeInput';
import {forwardClick} from 'directives/forwardClick';
import {growInput} from 'directives/growInput';
import {hiddenSelect} from 'directives/hiddenSelect';
import {icon} from 'directives/icon';
import {loadingBlock} from 'directives/loadingBlock';
import {loadingDots} from 'directives/loadingDots';
import {locationInput} from 'directives/locationInput';
import {modalDialog} from 'directives/modalDialog';
import {pickThreeDates} from 'directives/pickThreeDates';
import {prefixComplete} from 'directives/prefixComplete';
import {textLimit} from 'directives/textLimit';
import {timezoneSelect} from 'directives/timezoneSelect';
import {userInputAffinityGroups} from 'directives/userInputs/userInputAffinityGroups';
import {userInputAvailability} from 'directives/userInputs/userInputAvailability';
import {userInputCareerGoalsEmployers} from 'directives/userInputs/userInputCareerGoalsEmployers';
import {userInputCareerGoalsIndustries} from 'directives/userInputs/userInputCareerGoalsIndustries';
import {userInputCareerGoalsLocations} from 'directives/userInputs/userInputCareerGoalsLocations';
import {userInputCareerGoalsRoles} from 'directives/userInputs/userInputCareerGoalsRoles';
import {userInputConsultTypes} from 'directives/userInputs/userInputConsultTypes';
import {userInputCurrentLocation} from 'directives/userInputs/userInputCurrentLocation';
import {userInputEducation} from 'directives/userInputs/userInputEducation';
import {userInputEmailAndPhone} from 'directives/userInputs/userInputEmailAndPhone';
import {userInputEmploymentHistory} from 'directives/userInputs/userInputEmploymentHistory';
import {userInputGender} from 'directives/userInputs/userInputGender';
import {userInputGraduationDate} from 'directives/userInputs/userInputGraduationDate';
import {userInputLanguage} from 'directives/userInputs/userInputLanguage';
import {userInputName} from 'directives/userInputs/userInputName';
import {userInputPassword} from 'directives/userInputs/userInputPassword';
import {userInputPicture} from 'directives/userInputs/userInputPicture';
import {userInputPlatformAffiliation} from 'directives/userInputs/userInputPlatformAffiliation';
import {userInputPlatformAffiliationRelative} from 'directives/userInputs/userInputPlatformAffiliationRelative';
import {userInputPrimaryRole} from 'directives/userInputs/userInputPrimaryRole';
import {userInputProgramRestriction} from 'directives/userInputs/userInputProgramRestriction';
import {userInputRace} from 'directives/userInputs/userInputRace';
import {userInputSingleEducation} from 'directives/userInputs/userInputSingleEducation';
import {userInputSingleEmployment} from 'directives/userInputs/userInputSingleEmployment';
import {userInputExternalid} from 'directives/userInputs/userInputExternalid';
import {userInputVerticalServices} from 'directives/userInputs/userInputVerticalServices';
import {matchedExpert} from './matchedExpert';
import {tipContainer} from './tipContainer';
import {customInputSection} from 'directives/customInputSection';
import {customInputText} from 'directives/customInputText';
import {customInputRange} from 'directives/customInputRange';
import {customInputFile} from 'directives/customInputFile';
import {customInputMultipleChoice} from 'directives/customInputMultipleChoice';
import {userInputAvailabilitySpecific} from "../../angular-utilities/directives/userInputs/userInputAvailabilitySpecific";

export default DirectivesModule.

    directive('icon', icon).
    directive('forwardClick', forwardClick).
    directive('datetimeInput', datetimeInput).
    directive('loadingDots', loadingDots).
    directive('loadingBlock', loadingBlock).
    directive('timezoneSelect', timezoneSelect).
    directive('hiddenSelect', hiddenSelect).
    directive('modalDialog', modalDialog).
    directive('growInput', growInput).
    directive('textLimit', textLimit).
    directive('pickThreeDates', pickThreeDates).
    directive('dateInputText', dateInputText).
    directive('prefixComplete', prefixComplete).
    directive('locationInput', locationInput).

    directive('userInputPrimaryRole', userInputPrimaryRole).
    directive('userInputName', userInputName).
    directive('userInputExternalid', userInputExternalid).
    directive('userInputEmailAndPhone', userInputEmailAndPhone).
    directive('userInputPassword', userInputPassword).
    directive('userInputCurrentLocation', userInputCurrentLocation).
    directive('userInputPicture', userInputPicture).
    directive('userInputGraduationDate', userInputGraduationDate).
    directive('userInputPlatformAffiliation', userInputPlatformAffiliation).
    directive('userInputPlatformAffiliationRelative', userInputPlatformAffiliationRelative).
    directive('userInputEducation', userInputEducation).
    directive('userInputSingleEducation', userInputSingleEducation).
    directive('userInputAffinityGroups', userInputAffinityGroups).
    directive('userInputGender', userInputGender).
    directive('userInputRace', userInputRace).
    directive('userInputLanguage', userInputLanguage).
    directive('userInputConsultTypes', userInputConsultTypes).
    directive('userInputCareerGoalsLocations', userInputCareerGoalsLocations).
    directive('userInputCareerGoalsIndustries', userInputCareerGoalsIndustries).
    directive('userInputCareerGoalsEmployers', userInputCareerGoalsEmployers).
    directive('userInputCareerGoalsRoles', userInputCareerGoalsRoles).
    directive('userInputEmploymentHistory', userInputEmploymentHistory).
    directive('userInputSingleEmployment', userInputSingleEmployment).
    directive('userInputVerticalServices', userInputVerticalServices).
    directive('userInputAvailability', userInputAvailability).
    directive('userInputAvailabilitySpecific', userInputAvailabilitySpecific).
    directive('userInputProgramRestriction', userInputProgramRestriction).
    directive('matchedExpert', matchedExpert).
    directive('tipContainer', tipContainer).
    directive('customInputSection', customInputSection).
    directive('customInputText', customInputText).
    directive('customInputRange', customInputRange).
    directive('customInputFile', customInputFile).
    directive('customInputMultipleChoice', customInputMultipleChoice);
